import connect from "react-redux/es/connect/connect";
import { withRouter } from "react-router";
import React from "react";

function mapStateToProps(state) {
  const session = state.session;

  return {
    session,
  };
}

/*
 * Redirect to pages that are not logged in
 * */
export const withRedirectToAuth = (Component, redirectPath = "/login") => {
  const ComponentWithRedirect = ({ session, history, ...props }) => {
    if (!session) {
      history.replace(redirectPath);
      return null;
    } else {
      return <Component {...{ session, history, ...props }} />;
    }
  };

  return connect(mapStateToProps)(withRouter(ComponentWithRedirect));
};
/*
* 
will redirect from pages that cannot be opened when the user has a session
* */
export const withRedirectToHome = (Component, redirectPath = "/profile") => {
  const ComponentWithRedirect = ({ session, history, ...props }) => {
    if (session) {
      history.replace(redirectPath);
      return null;
    } else {
      return <Component {...{ session, history, ...props }} />;
    }
  };

  return connect(mapStateToProps)(withRouter(ComponentWithRedirect));
};
